import { hireBackgroundImage } from "assets/website";
import { SystemBadges, openSelarStore } from "../shared";

const TalentCta = () => {
  return (
    <section className="relative overflow-hidden bg-black">
      {/* Background pattern */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url(${hireBackgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-black/75" />

      <div className="relative z-10 mx-auto max-w-[900px] px-6 py-20 md:py-28 text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold text-white mb-6">
          Ready to Build a High-Performing Team?
        </h2>

        <SystemBadges className="mb-6" />

        <p className="mx-auto max-w-[640px] text-base md:text-lg text-neutral-300 mb-10">
          Start using PrecisionMatch to filter applicants, pick the strongest
          executors, and protect your team's performance.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={openSelarStore}
            className="w-full sm:w-auto px-8 py-4 bg-[#012169] hover:bg-[#011550] text-white text-base font-semibold rounded-[10px] transition-all duration-200 hover:shadow-lg"
          >
            Get the Complete Suite
          </button>
        </div>
      </div>
    </section>
  );
};

export { TalentCta };
